import { Component, OnInit, Input,Output ,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-summary-confirmation',
  templateUrl: './summary-confirmation.component.html',
  styleUrls: ['./summary-confirmation.component.sass']
})
export class SummaryConfirmationComponent implements OnInit {
  @Input() name;
  @Input() lastName;
  @Input() email;
  @Input() phoneNumber;
  @Input() role;
  constructor() { }

  ngOnInit() {
  }

}
